import { useEffect, useState } from "react";
import API from "../services/api";
import "./Payments.css";

export default function PaymentManagement() {
  const [payments, setPayments] = useState([]);

  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [search, setSearch] = useState("");

  // =========================
  // LOAD PAYMENTS
  // =========================
  const loadPayments = async () => {
    try {
      const res = await API.get(
        `/payments/?month=${month}&year=${year}`
      );

      setPayments(res.data.payments || []);
    } catch (err) {
      console.log("Payment load error:", err);
      setPayments([]);
    }
  };

  useEffect(() => {
    loadPayments();
  }, [month, year]);

  // =========================
  // TOGGLE PAID / UNPAID
  // =========================
  const toggleBilling = async (paymentId) => {
    try {
      await API.post(`/payments/toggle/${paymentId}/`);
      loadPayments();
    } catch (err) {
      alert("Billing update failed");
    }
  };

  // =========================
  // SEARCH FILTER
  // =========================
  const filteredPayments = payments.filter((p) =>
    p.school_name.toLowerCase().includes(search.toLowerCase())
  );

  const paidCount = filteredPayments.filter((p) => p.status === "paid").length;
  const unpaidCount = filteredPayments.length - paidCount;
  const totalDue = filteredPayments.reduce((sum, p) => sum + Number(p.monthly_due || 0), 0);
  const totalPaid = filteredPayments.reduce((sum, p) => sum + Number(p.total_paid || 0), 0);

  return (
    <div className="payment-container">
      <div className="payment-header">
        <div>
          <span className="page-kicker">Billing Control</span>
          <h2>Monthly School Billing</h2>
          <p>Track school dues, collection status, and plan expiry by month.</p>
        </div>
      </div>

      <div className="payment-summary-grid">
        <div className="payment-summary-card">
          <span>Total Due</span>
          <strong>₹{totalDue}</strong>
        </div>
        <div className="payment-summary-card paid">
          <span>Total Paid</span>
          <strong>₹{totalPaid}</strong>
        </div>
        <div className="payment-summary-card">
          <span>Paid Schools</span>
          <strong>{paidCount}</strong>
        </div>
        <div className="payment-summary-card pending">
          <span>Pending Schools</span>
          <strong>{unpaidCount}</strong>
        </div>
      </div>

      {/* FILTERS */}
      <div className="filters">

        {/* MONTH */}
        <select value={month} onChange={(e) => setMonth(e.target.value)}>
          {[...Array(12).keys()].map((m) => (
            <option key={m + 1} value={m + 1}>
              {new Date(0, m).toLocaleString("default", { month: "long" })}
            </option>
          ))}
        </select>

        {/* YEAR */}
        <select value={year} onChange={(e) => setYear(e.target.value)}>
          <option value="2025">2025</option>
          <option value="2026">2026</option>
          <option value="2027">2027</option>
        </select>

        {/* SEARCH */}
        <input
          type="text"
          placeholder="Search school..."
          className="search-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

      </div>

      {/* TABLE */}
      <div className="payment-table-wrapper">
        <table className="payment-table">
          <thead>
            <tr>
              <th>School</th>
              <th>Plan</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Paid</th>
              <th>Registered</th>
              <th>Plan Expiry</th>
            </tr>
          </thead>

          <tbody>
            {filteredPayments.length === 0 ? (
              <tr>
                <td colSpan="7" className="no-record">
                  No Records
                </td>
              </tr>
            ) : (
              filteredPayments.map((p) => (
                <tr key={p.id}>
                  <td className="payment-school">{p.school_name}</td>
                  <td>
                    <span className="payment-plan">{p.plan}</span>
                  </td>
                  <td>₹{p.monthly_due}</td>

                  <td>
                    <button
                      className={`status-toggle ${p.status}`}
                      onClick={() => toggleBilling(p.id)}
                    >
                      {p.status === "paid" ? "Paid" : "Unpaid"}
                    </button>
                  </td>

                  <td>₹{p.total_paid}</td>
                  <td>{p.registered}</td>
                  <td>{p.plan_expiry || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
